<template>
  <div class="gRow fRow jCenter aCenter fullWidth">
    <div class="fRow jBetween aCenter fullWidth" v-if="loaded">
      <span class="index">{{ indx }}</span>
      <div class="tableHead title big fCol aStart jCenter">
        <div class="teacherName">{{ data.title }}</div>
        <div class="teacherUsername fRow jStart aCenter">
          <i class="material-icons-round">grading</i>
          رشته‌ی {{ data.grade.field.title }}، {{data.grade.title}}</div>
        <div class="teacherUsername fRow jStart aCenter"
          v-if="data.lesson !== null">
          <i class="material-icons-round">menu_book</i>
          مربوط به درس {{data.lesson.title}}</div>
        <div class="teacherUsername fRow jStart aCenter"
          v-if="data.lesson === null">
          <i class="material-icons-round">wifi_tethering</i>
          آزمون جــــامــع</div>
        <div class="teacherUsername fRow jStart aCenter"
          v-if="data.examType === 2">
          <i class="material-icons-round">sync_disabled</i>
          آزمون تمرینی (غیر هماهنگ)</div>
        <div class="teacherUsername fRow jStart aCenter"
          v-if="data.examType === 1">
          <i class="material-icons-round">sync</i>
          آزمون هماهنگ</div>
      </div>
      <div class="tableHead state aCenter jCenter fCol">
        <i class="date material-icons-round"
          v-if="!data.dateOfExam.includes('0001-')">date_range</i>
        <span>{{computedDate}}</span>
      </div>
      <div class="tableHead state aCenter jCenter fCol">
        <switch-button
          @click.native="invertState"
          :val="examStatus"
          activeLabel="فعال"
          deactiveLabel="غیرفعال"
        />
      </div>
      <div class="tableHead state aCenter jCenter fCol">
        <div class="b fRow jStart aCenter mini"
          style="background-color: rgba(0,0,0,0.05) !important; padding: 2px 8px !important"
          @click="getResultForExam">
          <i class="material-icons-round">receipt_long</i>
          <label style="color: #383838">مشاهده</label>
        </div>
      </div>
      <div class="tableHead actions big">
        <i @click="showModal('examEdit')"
          class="material-icons-round">edit</i>
        <i @click="showModal('examDelete')"
          class="material-icons-round">clear</i>
      </div>
      <div class="modal fCol jCenter aCenter" v-if="modalShow">
        <div class="closer" @click="modalShow = false"></div>
        <div class="box fCol jStart aStart" v-if="examResultModal">
          <h4 class="fRow jStart aCenter">لیست نفرات شرکت کننده در آزمون
          </h4>
          <p>برای مشاهده عملکرد هر کدام از شرکت‌کننده‌ها فایل اکسل مربوطه را دانلود کنید</p>
          <ul class="fullWidth">
            <exam-excel
              v-for="(item, index) in resultArray"
              v-bind:key="index"
              :examName="data.title"
              :data="item"
              :indx="index" />
          </ul>
        </div>
        <div class="box fCol jStart aStart" v-if="examDeleteModal">
          <h4 class="fRow jStart aCenter">آیا از حذف «{{data.title}}» مطمئنید؟
          </h4>
          <p>این عملیات امکان بازگشت ندارد.</p>
          <div class="fRow jStart aCenter fullWidth" style="margin-top: 16px">
            <div class="b fRow jStart aCenter delete" @click="deleteExam">
              <i class="material-icons-round">delete</i>
              <label>بله، حذف شود</label>
            </div>
            <div class="b fRow jStart aCenter mini" @click="modalShow = false">
              <i class="material-icons-round">close</i>
              <label>انصراف و بازگشت</label>
            </div>
          </div>
        </div>
        <div class="box fCol jStart aStart editModal" v-if="examEditModal">
          <add-exam mode="edit" :init="data" />
        </div>
      </div>
    </div>
    <p-bar
      :loading="loading"
      :mini="true"
      :notYet="notYet"
      :noContent="noContent"
      :notFound="notFound"
      :error="error" />
  </div>
</template>

<script>
import axios from 'axios';
import SwitchButton from '@/components/SwitchButton.vue';
import pBar from '@/components/pBar.vue';
import AddExam from '@/components/AddExam.vue';
import ticks from '@/mixins/ticks';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import moment from 'moment-jalaali';
import ExamExcel from '@/components/ExamExcel.vue';
import { EventBus } from '@/plugins/event-bus';

export default {
  mixins: [errorHandler, makeToast, ticks],
  props: ['data', 'indx'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      examStatus: false,
      modalShow: false,
      examDeleteModal: false,
      examResultModal: false,
      examEditModal: false,
      resultArray: [
        {
          id: 68468413313200,
          name: 'علی احمدی',
          score: 67.5,
        },
        {
          id: 68346841313200,
          name: 'علی احمدی',
          score: 98.5,
        },
        {
          id: 68468413132400,
          name: 'علی احمدی',
          score: 17.5,
        },
        {
          id: 68468541313200,
          name: 'علی احمدی',
          score: 37,
        },
        {
          id: 68468413173200,
          name: 'علی احمدی',
          score: 57.5,
        },
      ],
    };
  },
  methods: {
    showModal(modal) {
      this.modalShow = true;
      this.examDeleteModal = false;
      this.examResultModal = false;
      this.examEditModal = false;
      switch (modal) {
        case 'examDelete': {
          this.examDeleteModal = true;
          break;
        }
        case 'examResult': {
          this.examResultModal = true;
          break;
        }
        case 'examEdit': {
          this.examEditModal = true;
          break;
        }
        default:
          break;
      }
    },
    // عوض کردن وضعیت
    invertState() {
      this.setMode('loading');
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Exams/${this.data.id}/?status=${!this.examStatus}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
            // alert(response);
            this.examStatus = !this.examStatus;
            if (this.examStatus) {
              this.makeToast('success', 'آزمون مورد نظر فعال شد', 2000);
            } else {
              this.makeToast('success', 'آزمون مورد نظر غیرفعال شد', 2000);
            }
          } else {
            this.setMode('loaded');
            this.makeToast('success', 'دوباره تلاش کنید', 2000);
          }
        },
        (error) => {
          this.whileState = false;
          // console.log(error);
          this.setMode('loaded');
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
    editExam() {
      // console.log('edit exam');
    },
    deleteExam() {
      this.modalShow = false;
      this.setMode('loading');
      axios({
        method: 'delete',
        url: `${this.baseURL}/api/v${this.V}/Exams/${this.data.id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
            // alert(response);
            this.examStatus = !this.examStatus;
            this.makeToast('success', 'آزمون مورد نظر حذف شد شد', 2000);
            this.$emit('refreshExam');
          } else {
            this.setMode('loaded');
            this.makeToast('success', response.data.message, 4000);
          }
        },
        (error) => {
          this.whileState = false;
          // console.log(error);
          this.setMode('loaded');
          this.makeToast('error', this.errorHandler(error), 3000);
        },
      );
    },
    // تابع دریافت اطلاعات مخصوص دبیر
    getTeacherInfo(init) {
      if (!this.expanded) {
        axios({
          method: 'get',
          url: `${this.baseURL}/api/v${this.V}/Teachers/${this.id}/info`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              this.expanded = true;
              this.tDesc = JSON.parse(JSON.stringify(response.data.data.description));
              this.tSummary = JSON.parse(JSON.stringify(response.data.data.summary));
              if (!init || init === undefined) {
                this.lessonId = response.data.data.lessonIds;
                this.$emit('showTeacherInfo', {
                  teacher: JSON.parse(JSON.stringify(response.data.data)),
                  order: 'open',
                });
              } else {
                this.lessonId = response.data.data.lessonIds;
                this.$emit('showTeacherInfo', {
                  teacher: JSON.parse(JSON.stringify(response.data.data)),
                  order: 'init',
                });
              }
              // console.log(JSON.parse(JSON.stringify(response.data.data)));
              // alert(this.lessonsId);
            }
          },
          (error) => {
            // console.log(error);
            this.makeToast('error', this.errorHandler(error), 2000);
          },
        );
      } else {
        this.expanded = false;
        this.$emit('closeRow');
      }
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    // دریافت اسامی و اطلاعات دانش آموزان
    getResultForExam() {
      axios({
        method: 'get',
        url: `${this.baseURL}/api/v${this.V}/Results/${this.data.id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            const r = response.data.data;
            this.resultArray = [];
            for (let i = 0; i < r.length; i += 1) {
              const a = {
                id: r[i].resultId,
                mobile: r[i].mobile,
                name: `${r[i].firstName} ${r[i].lastName}`,
              };
              this.resultArray.push(a);
            }
            this.showModal('examResult');
          }
        },
        (error) => {
          // console.log(error);
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
  },
  components: {
    SwitchButton,
    pBar,
    AddExam,
    ExamExcel,
  },
  computed: {
    computedDate() {
      let a = '';
      if (!this.data.dateOfExam.includes('0001-')) {
        a = moment(this.data.dateOfExam, 'YYYY-MM-DDTHH:mm:ss')
          .locale('FA')
          .format('dd - jDD jMMMM jYY');
      } else {
        a = 'بدون تاریخ';
      }
      return a;
    },
  },
  mounted() {
    this.examStatus = this.data.status;
    EventBus.$on('editDone', () => {
      this.modalShow = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.gRow {
  padding: 16px 0px;
  transition: all cubic-bezier(0.5, 0, 0, 1) 0.5s;
  height: 162px;
}

.teacherName {
  font-size: 14px;
  word-spacing: -2px;
  text-align: right;
}

.editModal {
  width: 1080px !important;
  height: 90%;
}

.teacherUsername {
  font-size: 13px;
  font-weight: 100;
  word-spacing: -2px;
  text-align: right;
  padding: 2px 4px;
  border-radius: 8px;
  background-color: rgba($color: #000000, $alpha: 0.05);
  margin-top: 8px;
  i {
    color: rgba($color: #000000, $alpha: 0.45);
    font-size: 14px;
    margin-left: 8px;
  }
}

.state {
  i.date {
    font-size: 16px;
    opacity: 1;
    margin-bottom: 8px;
    color: rgb(84, 128, 84);
  }
}

.teacherLoginAt {
  font-size: 12px;
  font-weight: 200;
}

.gRow:hover {
  background-color: rgba($color: #000000, $alpha: 0.02);
}

.wait {
  opacity: 0.3;
  filter: grayscale(100%);
}

.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.55);
  z-index: 900000000000000000000;
  .closer {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
  }
  .box {
    border-radius: 8px;
    background-color: white;
    max-height: 80%;
    overflow: hidden auto;
    width: 30%;
    min-width: 512px;
    padding: 16px;
    z-index: 20;
    box-shadow: 0 8px 24px 0 rgba($color: #000000, $alpha: 0.25),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.25);
    h4 {
      font-size: 14px;
      padding: 0;
      margin: 0;
    }
    p {
      font-size: 12px;
      padding: 0 0 8px 0;
      margin: 8px 0 0 0;
      width: 100%;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
    }
    ul {
      padding: 0;
      margin: 0;
    }
  }
}
</style>
